import axios from 'axios';
import { authState } from './authState';


axios.defaults.withCredentials = true;

const apiClient = axios.create({
    //baseURL: 'http://localhost:5193'
    baseURL: '/api'
});

apiClient.interceptors.response.use(
    response => response,
    error => {

        if (authState.isLoggedIn && error.response.status === 401) {
            localStorage.clear();
            alert("You have been logged out for inactivity!")
            window.location.reload()
        } else if (error.response.status === 400) {
            alert(JSON.stringify(error.response.data.title != null ? error.response.data.title : error.response.data, null, 2))
        }

        return Promise.reject(error);
    }
)

export default {
    get(resource) {
        return apiClient.get(resource);
    },
    post(resource, data) {
        return apiClient.post(resource, data);
    },
};